// Play video
document.addEventListener("DOMContentLoaded", function () {
	const video = document.querySelector(".mm-main-article-video");
	const playButton = document.querySelector(".mm-main-article-video-play-btn");
	const title = document.querySelector(".mm-main-article-video-title");
	const videoFilter = document.querySelector(".mm-main-article-video-filter");

	playButton.addEventListener("click", function () {
		if (video.paused) {
			video.play();
			title.style.display = "none";
			playButton.style.display = "none";
			videoFilter.style.display = "none";
		}
	});
});

// Summary / anchors desktop

// Add a unique id based on loopindex
const titles = document.querySelectorAll(".mm-main-article-content h2");
const tableOfContentContainer = document.querySelector(".mm-main-article-lead-magnet-summary");
const tableOfContent = document.querySelector(".mm-main-article-lead-magnet-titles");
const tableOfContentList = document.createElement("ul");

console.log("TITLES", titles);

if (titles.length > 0) {
	titles.forEach((title, index) => {
		title.id = `titre-${index + 1}`;

		const listItem = document.createElement("li");
		const link = document.createElement("a");
		link.classList.add("mm-main-article-lead-magnet-title", "mm-text-600");
		link.href = `#${title.id}`;
		link.textContent = title.textContent;

		listItem.appendChild(link);

		tableOfContentList.appendChild(listItem);
	});
}

if (titles.length === 0) {
	tableOfContentContainer.style.display = "none";
} else {
	tableOfContentContainer.style.display = "block";
}

tableOfContent.appendChild(tableOfContentList);

// Scroll behaviour (smooth & at the right place)
const tocLinks = tableOfContent.querySelectorAll("a");

tocLinks.forEach((tocLink) => {
	tocLink.addEventListener("click", function (event) {
		event.preventDefault();
		// get the anchor
		const targetId = this.getAttribute("href").substring(1); // delete #
		const targetElement = document.getElementById(targetId);

		targetElement.scrollIntoView({
			behavior: "smooth",
			block: "center",
		});
	});
});

// lead magnet in the middle of the screen during the scroll

window.addEventListener("scroll", function () {
	const stickyElement = document.querySelector(".mm-main-article-right");
	const scrollY = window.scrollY;
	const viewportHeight = window.innerHeight;

	const startScroll = 0;

	const targetTop = viewportHeight / 2 - stickyElement.offsetHeight / 2;

	if (scrollY >= startScroll) {
		let newTop = 452 - (scrollY - startScroll) / 2;

		newTop = Math.max(targetTop, newTop);

		stickyElement.style.top = `${newTop}px`;
	} else {
		stickyElement.style.top = "452px";
	}
});

// Summary / anchors mobile

if (window.innerWidth <= 768) {
	if (titles.length === 0) {
		document.querySelector(".mm-main-article-table-of-contents-mobile").style.display = "none";
	} else {
		document.querySelector(".mm-main-article-table-of-contents-mobile").style.display = "block";
	}
}

document.addEventListener("DOMContentLoaded", function () {
	const tocContainer = document.querySelector(".mm-custom-select .mm-select-items");
	const selectedDiv = document.querySelector(".mm-custom-select .mm-select-selected");

	// Vérifie si des balises H2 existent
	if (titles.length > 0) {
		// Affiche le premier titre H2 par défaut
		selectedDiv.textContent = titles[0].textContent;
	}

	titles.forEach((title, index) => {
		if (!title.id) {
			title.id = `section${index + 1}`;
		}

		const optionDiv = document.createElement("div");
		optionDiv.textContent = title.textContent;
		optionDiv.setAttribute("data-link", `#${title.id}`);
		tocContainer.appendChild(optionDiv);

		optionDiv.addEventListener("click", function () {
			selectedDiv.textContent = this.textContent;
			const selectedSection = document.querySelector(this.getAttribute("data-link"));
			if (selectedSection) {
				window.scrollTo({
					top: selectedSection.offsetTop,
					behavior: "smooth",
				});
			}
			closeAllSelect();
		});
	});

	selectedDiv.addEventListener("click", function (e) {
		e.stopPropagation();
		closeAllSelect(this);
		this.classList.toggle("select-arrow-active");
		tocContainer.classList.toggle("mm-hide");
	});

	document.addEventListener("click", closeAllSelect);

	function closeAllSelect(elm) {
		const selectItems = document.querySelectorAll(".mm-select-items");
		const selectedItems = document.querySelectorAll(".mm-select-selected");

		selectedItems.forEach((item, i) => {
			if (elm !== item) {
				item.classList.remove("select-arrow-active");
			}
		});

		selectItems.forEach((item, i) => {
			if (!item.classList.contains("mm-hide")) {
				item.classList.add("mm-hide");
			}
		});
	}
});

// Lead magnet NL mobile

const mobileCta = document.querySelector(".mm-lead-magnet-nl-mobile-cta");
const mobileNl = document.querySelector(".mm-main-article-lead-magnet-nl-mobile-klaviyo");
const klaviyoBtn = document.querySelector(".mm-main-article-lead-magnet-nl-mobile-klaviyo button");
const mobileGuideTitleBtn = document.querySelector(".mm-main-article-lead-magnet-nl-mobile-title-btn");

mobileCta.addEventListener("click", function () {
	mobileGuideTitleBtn.style.display = "none";
	mobileNl.style.display = "block";
});

klaviyoBtn.addEventListener("click", function () {
	setTimeout(function () {
		document.querySelector(".mm-main-article-lead-magnet-nl-mobile").style.display = "none";
	}, 5000);
});
